export class pdQaqcReq{
  pdId: number;

  constructor(pdId: number){
      this.pdId = pdId;
  }
}